import { render } from "./ModalLanguage.vue?vue&type=template&id=7507895a"
import script from "./ModalLanguage.vue?vue&type=script&lang=js"
export * from "./ModalLanguage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__